import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Icon } from "antd";
import BasicLayout from "../common/BasicLayout";
import styled from "styled-components";

const CustomAtag = styled.a`
  display: block
  font-size: 15px;
  font-weight: 700 !important;
  color: rgba(0, 0, 0, 0.85);

  @media (min-width: 992px) {
    font-size: 25px;
  }
`;

const CustomLink = styled(Link)`
  display: block
  font-size: 15px;
  font-weight: 700 !important;
  color: rgba(0, 0, 0, 0.85);

  @media (min-width: 992px) {
    font-size: 25px;
  }
`;

const CustomIcon = styled(Icon)`
  font-size: 50px;
`;

export default class Main extends Component {
  render() {
    return (
      <BasicLayout>
        <Row style={{ textAlign: "center", margin: "50px auto 0 auto" }}>
          <Col span={24} style={{ marginBottom: 50 }}>
            <CustomIcon type="audit" />
            <CustomAtag
              target="_blank"
              rel="noopener"
              href="http://appddictionstudio.com/HCDE/#"
            >
              Edgar Procurement Forms &amp; Reporting
            </CustomAtag>
          </Col>
          <Col span={24} style={{ marginBottom: 50 }}>
            <CustomIcon type="bank" />
            <CustomLink to="/federal-grant-contract-salary">
              Federal Grant/Contract Salary Forms &amp; Reporting
            </CustomLink>
          </Col>
          <Col span={24}>
            <CustomIcon type="team" />
            <CustomLink to="/admin">Admin Login</CustomLink>
          </Col>
        </Row>
      </BasicLayout>
    );
  }
}
